import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

import Button from "@/components/button.vue"
  import CustomerEditor from "@/components/editors/customer.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {Customer as CustomerResolver} from "@/endpoints/rutsolve/gql/resolvers/customer"
  import {ContactDetails as ContactDetailsResolver} from "@/endpoints/rutsolve/gql/resolvers/contact_details"
  import {ref} from "vue"
  import {
    ContactDetails,
    Customer,
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import router from "@/router"
  import ErrorModal from "@/components/modals/error.vue"
  import ContactDetailsList from "@/components/lists/contact_details.vue"
  import ContactDetailsEditor from "@/components/editors/contact_details.vue"
  import ContentModal from "@/components/modals/content.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'create_customer',
  setup(__props) {

  const error = ref<Error>(null)
  const customerResolver = new CustomerResolver()
  const contactDetailsResolver = new ContactDetailsResolver()
  const selectedContactDetails = ref<ContactDetails>(null)
  const selectedContactDetailsIndex = ref<number>(null)
  const customer = ref<Customer>({
    contactDetails: {
      records: [],
    }
  })

  async function save() {
    try {
      const customerID = await customerResolver.create(customer.value)
      if (customer.value.contactDetails && customer.value.contactDetails.records) {
        for (const contactDetails of customer.value.contactDetails.records) {
          if (contactDetails.deletedAt) {
            continue
          }
          contactDetails.relationID = customerID
          contactDetails.relationType = "CUSTOMER"
          await contactDetailsResolver.create(contactDetails)
        }
      }
      customerRedirect()
    } catch(e) {
      error.value = e
    }
  }

  function customerRedirect() {
    router.push({
      name: "customers"
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [
          _createVNode(Breadcrumb, {
            links: [{
          title: 'RutSolve',
          routeName: 'index'
        }, {
          title: 'Customers',
          routeName: 'customers'
        }],
            title: "Create"
          }),
          _cache[10] || (_cache[10] = _createElementVNode("h1", null, " Create Customer ", -1)),
          _createVNode(CustomerEditor, {
            value: customer.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((customer).value = $event))
          }, null, 8, ["value"]),
          _cache[11] || (_cache[11] = _createElementVNode("h2", null, " Contact Details ", -1)),
          (customer.value.contactDetails)
            ? (_openBlock(), _createBlock(ContactDetailsList, {
                key: 0,
                items: customer.value.contactDetails.records,
                "onUpdate:items": _cache[1] || (_cache[1] = ($event: any) => ((customer.value.contactDetails.records) = $event)),
                selectedIndex: selectedContactDetailsIndex.value,
                "onUpdate:selectedIndex": _cache[2] || (_cache[2] = ($event: any) => ((selectedContactDetailsIndex).value = $event)),
                onSelect: _cache[3] || (_cache[3] = ($event: any) => (selectedContactDetails.value = customer.value.contactDetails.records[selectedContactDetailsIndex.value]))
              }, null, 8, ["items", "selectedIndex"]))
            : _createCommentVNode("", true),
          (selectedContactDetails.value)
            ? (_openBlock(), _createBlock(ContentModal, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(ContactDetailsEditor, {
                    value: selectedContactDetails.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((selectedContactDetails).value = $event))
                  }, null, 8, ["value"]),
                  _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                  _createVNode(Button, {
                    title: "Apply",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (selectedContactDetails.value = null))
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(Button, {
            title: "Cancel",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (customerRedirect()))
          }),
          _createVNode(Button, {
            title: "Save",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (save()))
          })
        ]),
        _: 1
      }),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 0,
            error: error.value,
            "onUpdate:error": _cache[8] || (_cache[8] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})